import { api } from '@here/api'
import { ListTypes, type Pagination } from '..'
import type { SetupFilter } from '../filter'

export const handleGetTaken = async (
	listType: ListTypes,
	filters: SetupFilter,
	userId?: string,
	pagination?: Pagination,
) => {
	if (listType !== ListTypes.taken || !userId || !pagination) {
		return []
	}

	let query = api()
		.from('taken_setups')
		.select('setup_id, setup(*)')
		.eq('has_taken', true)
		.eq('user_id', userId)

	// if (filters.duration.length) {
	// 	query = query.in('duration', filters.duration)
	// }

	// if (filters.symbols.length) {
	// 	query = query.in('symbol', filters.symbols)
	// }

	// if (filters.assetType.length) {
	// 	query = query.in('market', filters.assetType)
	// }

	// if (filters.patternSpecification.length) {
	// 	query = query.in('pattern_specification', filters.patternSpecification)
	// }

	// if (filters.position.length) {
	// 	query = query.in('position', filters.position)
	// }

	// if (filters.stage.length) {
	// 	query = query.in('stage', filters.stage)
	// }

	// query = query.order('taken_count', { ascending: false })

	// TODO add this back in so order is combined
	// for (const [order, ascending] of Object.entries(filters.order)) {
	// 	if (ascending !== undefined) {
	// 		query = query.order(order, { ascending })
	// 	}
	// }

	// Apply limit + offset
	if (pagination.limit !== undefined && pagination.offset !== undefined) {
		query = query.range(pagination.offset, pagination.offset + pagination.limit - 1)
	}

	const { data } = await query
	return data?.map(({ setup }) => setup) || []
}
